import React from 'react';
import { Navbar, Container, Nav, Dropdown } from 'react-bootstrap';
import { NavLink } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import wavive_logo from '../../assets/images/logo_main.png';

const Header = ({ user, onLogout }) => {
    return (
        <Navbar className="waive-header" expand="lg">
            <Container fluid style={{ maxWidth: 1200 }}>
                <Navbar.Brand as={NavLink} to="/" className="d-flex align-items-center">
                    <span className="brand-icon">
                        <img src={wavive_logo} width={108} alt="Waive Logo" />
                    </span>
                </Navbar.Brand>

                <Navbar.Toggle aria-controls="waive-nav" />
                <Navbar.Collapse id="waive-nav">
                    <Nav className="me-auto">
                        <Nav.Link as={NavLink} to="/" end>
                            <FontAwesomeIcon icon="clipboard-list" className="me-1" />
                            Assessment
                        </Nav.Link>
                        <Nav.Link as={NavLink} to="/methodology">
                            <FontAwesomeIcon icon="file-alt" className="me-1" />
                            Methodology
                        </Nav.Link>
                        {user?.role === 'admin' && (
                            <Nav.Link as={NavLink} to="/admin">
                                <FontAwesomeIcon icon="cog" className="me-1" />
                                Configuration
                            </Nav.Link>
                        )}
                    </Nav>

                    {/* User Profile Menu */}
                    {user && (
                        <Nav>
                            <Dropdown align="end">
                                <Dropdown.Toggle
                                    as={Nav.Link}
                                    className="user-menu-toggle d-flex align-items-center"
                                >
                                    <div className="user-avatar">
                                        <FontAwesomeIcon icon="user-circle" size="lg" />
                                    </div>
                                    <div className="user-info d-none d-md-flex">
                                        <span className="user-name">{user.display_name || user.username}</span>
                                        <span className="user-provider">{user.provider}</span>
                                    </div>
                                    <FontAwesomeIcon icon="chevron-down" className="dropdown-arrow d-none d-md-inline" />
                                </Dropdown.Toggle>

                                <Dropdown.Menu className="user-dropdown-menu">
                                    <div className="dropdown-header-section">
                                        <div className="dropdown-user-avatar">
                                            <FontAwesomeIcon icon="user-circle" size="2x" />
                                        </div>
                                        <div className="dropdown-user-details">
                                            <div className="dropdown-user-name">{user.display_name || user.username}</div>
                                            <div className="dropdown-user-email">{user.username}@{user.provider?.toLowerCase()}.com</div>
                                            <span className={`dropdown-user-badge ${user.role === 'admin' ? 'badge-admin' : 'badge-user'}`}>
                                                {user.role === 'admin' ? 'Administrator' : 'User'}
                                            </span>
                                        </div>
                                    </div>

                                    <Dropdown.Divider />

                                    <Dropdown.Item className="dropdown-item-with-icon">
                                        <FontAwesomeIcon icon="user" className="dropdown-item-icon" />
                                        My Profile
                                    </Dropdown.Item>

                                    {user.role === 'admin' && (
                                        <Dropdown.Item as={NavLink} to="/admin" className="dropdown-item-with-icon">
                                            <FontAwesomeIcon icon="cog" className="dropdown-item-icon" />
                                            Settings
                                        </Dropdown.Item>
                                    )}

                                    <Dropdown.Item className="dropdown-item-with-icon">
                                        <FontAwesomeIcon icon="question-circle" className="dropdown-item-icon" />
                                        Help & Support
                                    </Dropdown.Item>

                                    <Dropdown.Divider />

                                    <Dropdown.Item
                                        onClick={onLogout}
                                        className="dropdown-item-with-icon dropdown-item-logout"
                                    >
                                        <FontAwesomeIcon icon="sign-out-alt" className="dropdown-item-icon" />
                                        Sign Out
                                    </Dropdown.Item>
                                </Dropdown.Menu>
                            </Dropdown>
                        </Nav>
                    )}
                </Navbar.Collapse>
            </Container>
        </Navbar>
    );
};

export default Header;